import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

import { AppService } from './app.service';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  private _encryptionKey = '';

  constructor(private appService: AppService) {
    this._encryptionKey = this.appService.getAppSettings().enfPkg.cfgE;
  }

  encryptData(dataToEncrypt: string): string {
    const encryptedData = CryptoJS.AES.encrypt(dataToEncrypt, this._encryptionKey).toString();
    return encryptedData;
  }

  decryptData(dataToDecrypt: string) {
    const decryptedDataBytes = CryptoJS.AES.decrypt(dataToDecrypt, this._encryptionKey).toString(CryptoJS.enc.Utf8);
    return decryptedDataBytes;
  }
}
